/**
 * The product modules an instance can be sold, with their labels.
 *
 * MIRROR of backend/src/lib/moduleCatalog.ts, the source of truth; keep in
 * sync (backend/test/moduleCatalogMirrors.test.ts checks).
 */
export interface ModuleEntry {
  key: string;
  label: string;
  parent?: string;
  /** Always on: never withheld from a tenant. */
  core?: boolean;
  /** Built for one customer: off everywhere until granted (see backend lib/modules.ts). */
  optIn?: boolean;
}

export const MODULE_CATALOG: readonly ModuleEntry[] = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'dailySummary', label: 'Rezumat zilnic' },
  { key: 'weeklySummary', label: 'Rezumat săptămânal' },
  { key: 'aiAssistant', label: 'Firmio AI' },
  { key: 'mcp', label: 'Firmio MCP', parent: 'aiAssistant' },
  { key: 'videoMeetings', label: 'Firmio Meet' },
  { key: 'teamChat', label: 'Chat echipă' },
  { key: 'reminders', label: 'Remindere' },
  { key: 'leave', label: 'Concedii' },
  { key: 'tasks', label: 'Sarcini', core: true },
  { key: 'calendar', label: 'Calendar', parent: 'tasks' },
  { key: 'taskReports', label: 'Rapoarte sarcini', parent: 'tasks' },
  { key: 'meetings', label: 'Întâlniri' },
  { key: 'leads', label: 'Pipeline' },
  { key: 'projects', label: 'Proiecte', core: true },
  { key: 'clients', label: 'Clienți' },
  { key: 'clientTasks', label: 'Sarcini', parent: 'clients' },
  { key: 'clientTeam', label: 'Echipă', parent: 'clients' },
  { key: 'socialPosts', label: 'Calendar postări', parent: 'clients' },
  { key: 'suppliers', label: 'Furnizori' },
  { key: 'subscriptions', label: 'Abonamente' },
  { key: 'financials', label: 'Financiar' },
  { key: 'invoices', label: 'Facturi', parent: 'financials' },
  { key: 'spv', label: 'SPV', parent: 'financials' },
  { key: 'bankStatements', label: 'Extrase bancare', parent: 'financials' },
  { key: 'cashflow', label: 'Cashflow', parent: 'financials' },
  { key: 'monthlyReports', label: 'Rapoarte lunare', parent: 'financials' },
  { key: 'actors', label: 'Actori', optIn: true },
  { key: 'whatsapp', label: 'WhatsApp', optIn: true },
];

/** The modules "all modules" covers (opt-in ones are granted separately). */
export const ALL_MODULE_KEYS = MODULE_CATALOG.filter((m) => !m.optIn).map((m) => m.key);

/** Built for one customer: granted one by one (Tenant.optInModules). */
export const OPT_IN_MODULES = MODULE_CATALOG.filter((m) => m.optIn);

export function moduleLabel(key: string): string {
  const m = MODULE_CATALOG.find((x) => x.key === key);
  if (!m) return key;
  const parent = m.parent && MODULE_CATALOG.find((x) => x.key === m.parent);
  return parent ? `${parent.label} → ${m.label}` : m.label;
}
